<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import AppShell from "@/components/AppShell.vue";
import { useSession } from "@/composables/session";

const route = useRoute();
const { session } = useSession();
const isLogin = computed(() => route.name === "login");
</script>

<template>
  <RouterView v-if="isLogin" v-slot="{ Component }">
    <Transition name="route" mode="out-in"
      ><component :is="Component"
    /></Transition>
  </RouterView>
  <AppShell v-else-if="session?.authenticated" :session="session">
    <RouterView v-slot="{ Component }">
      <Transition name="route" mode="out-in"
        ><component :is="Component"
      /></Transition>
    </RouterView>
  </AppShell>
  <main v-else class="bootstrap-state" aria-live="polite">
    <span class="signal-dot signal-dot--live" />
    <p>Initialisation du Signal Desk…</p>
  </main>
</template>

<style>
.route-enter-active,
.route-leave-active {
  transition:
    opacity 150ms ease,
    transform 180ms ease;
}
.route-enter-from {
  opacity: 0;
  transform: translateY(0.4rem);
}
.route-leave-to {
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .route-enter-active,
  .route-leave-active {
    transition: none;
  }
}
</style>

<style scoped>
.bootstrap-state {
  display: grid;
  min-height: 100svh;
  place-content: center;
  justify-items: center;
  gap: 0.8rem;
  color: var(--paper);
  background: var(--night);
}
.bootstrap-state p {
  font: 0.7rem var(--font-mono);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
</style>
